import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TranslateService } from '@app/core/services/translate.service';
import { CsvService } from '@app/services/csv.service';

@Component({
    selector: 'tt-csv-import',
    templateUrl: './csv-import.component.html',
    styleUrls: ['./csv-import.component.css'],
    standalone: false,
})
export class CsvImportComponent implements OnInit {
    @ViewChild('fileInput')
    public fileInput?: ElementRef<HTMLInputElement>;

    public loadingFile = false;

    private translations = {
        error: 'error',
        ok: 'ok'
    };

    constructor(
        private csv: CsvService,
        private modal: ModalService,
        private translate: TranslateService
    ) {}

    public async ngOnInit(): Promise<void> {
        const translations: Partial<typeof this.translations> = await this.translate.translateBatch(['error', 'ok']);
        this.translations = { ...this.translations, ...translations };
    }

    public selectFile(): void {
        if (!this.loadingFile) this.fileInput?.nativeElement.click();
    }

    public async fileChanged(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (!file || this.loadingFile) return;

        this.loadingFile = true;

        try {
            const content = await file.text();
            input.value = '';

            if (!content.trim()) return;

            const response = await this.csv.importFileCsv(content);

            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
        } catch (error) {
            input.value = '';

            await this.showWarning(error instanceof Error ? error.message : 'The CSV file could not be imported.');
        } finally {
            this.loadingFile = false;
        }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({
            type: 'warning',
            title: this.translations.error, message,
            buttons: [{
                label: this.translations.ok,
                cssClass: 'btn-warning',
                type: 'warning',
                close: true
            }]
        });
    }
}
